import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  TextField,
  Button,
  Box
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import { useDocumentsContext } from '../../context/document_context';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { firebaseStore } from '../../storage/base';
import { useClientContext } from '../../context/client_context';
import { ClientListHead, ClientMoreMenu } from '../_dashboard/clients';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import ClaimsDocs from '../claims/ClaimsDocs';
import DocumentsAdd from '../dependants/DocumentsAdd';
import DocsMainAdd from './DocsMainAdd';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'uploadDate', label: 'Upload Date', alignRight: false },
  { id: 'documentType', label: 'Document Type', alignRight: false },
  { id: 'fileName', label: 'File Name', alignRight: false },
  { id: 'documentExpiryDate', label: 'Expiry Date', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'ee', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function DocumentsMain(props) {
  const { currentClient } = useClientContext();
  const { mainDocuments, setMainDocs, populateMainDocuments } = useDocumentsContext();
  const tenant = sessionStorage.getItem('userRefId');
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [documentRefId, setDocRefId] = useState(0);
  const [claimRefIds, setClaimRefId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupDiag, setOpenPopupDiag] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });

  useEffect(() => {
    if (currentClient.cif_number > 1) populateMainDocuments(currentClient.cif_number);
    // populateDocumentsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainDocuments]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient.cif_number]);

  const validateDocument = (e) => {
    const payLoad = {
      RefId: e.row.refId,
      UploadDate: e.row.uploadDate,
      DocumentType: e.row.documentType,
      DocumentTypeName: '',
      DocumentPath: e.row.documentPath,
      OriginalFileName: e.row.originalFileName,
      DocumentFilename: e.row.documentFilename,
      IsValidated: true,
      ValidationDate: null,
      IsOutStanding: false,
      State: 1,
      DocumentExpiryDate: e.row.documentExpiryDate,
      MimeType: e.row.mimeType,
      OcrScanned: false
    };

    const jsonDoc = [];
    jsonDoc.push(payLoad);

    console.log('current Docs stringified now', JSON.stringify(jsonDoc));
    fetch(`${baseUrl}/api/client/validateDocument?userRefId=${tenant}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonDoc[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('document validate result after save', result);
          //   populateClaimDocuments(claimNo);
          //   getClaimById(claimNo);
          notifyPopup('Document Validated Successfully', 'success');
        },
        (error) => {
          notifyPopup(`Error in Validating Document!: ${error}`, 'error');
        }
      );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = mainDocuments.map((n) => n.documentType);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDocView = (e) => {
    // window.open(e.documentPath, '_blank');
    console.log('e doc is', e);
    window.open(`${baseUrl}/api/FileUpload/GetFile?RefId=${e.row.refId}`, '_blank');
  };

  const setVerified = (e) => {
    console.log(e);
  };

  const getDocType = (e) => {
    switch (e.documentType) {
      case 1:
        return 'Member ID Doc';
      case 2:
        return 'Payslip';
      case 23:
        return 'Retirement Letter';
      case 34:
        return 'Birth Doc';
      case 35:
        return 'Proof of Death';
      case 36:
        return 'Claimant ID';
      case 37:
        return 'Claim Form';
      case 38:
        return 'Affidavit';
      case 39:
        return 'Nomination Form';
      case 40:
        return 'Marriage Doc';
      default:
        return 'Unknown';
    }
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - mainDocuments.length) : 0;

  const filteredUsers = applySortFilter(mainDocuments, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const closePopup = () => {
    setOpenPopup(false);
  };

  const closePopupDiag = () => {
    setOpenPopupDiag(false);
  };

  const newLine = () => {
    // clearLineItem();
    setOpenPopupDiag(true);
  };

  const handleDocUpdate = (e) => {
    // clearLineItem();
    console.log('doc line', e.refId, 'claimid ', e.claimRefId);
    setDocRefId(e.refId);
    setClaimRefId(0);
    setOpenPopup(true);
  };

  const handleDocDelete = (e) => {
    console.log('e iyi:', e);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });

    deleteDocumentFromDb(e.row.refId);
    // const fileUrl = e.row.documentPath;

    // const fileRef = firebaseStore.storage().refFromURL(fileUrl);

    // fileRef
    //   .delete()
    //   .then(() => {
    //     console.log('Document Deleted Successfully');
    //     deleteDocumentFromDb(e.row.refId);
    //   })
    //   .catch((error) => {
    //     notifyPopup(`Error in Deleting Document!: ${error}`, 'error');
    //   });
  };

  const deleteDocumentFromDb = async (e) => {
    console.log('apa pa 2e iyi:', e);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    fetch(`${baseUrl}/api/client/DeleteDocument?documentRefId=${e}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Deleting SSB Entry!: ${result.replyMessage}`, 'error');
          } else {
            notifyPopup(`SSB Submission Entry Deleted Successfully!`, 'success');
            populateMainDocuments(currentClient.cif_number);
          }
        },
        (error) => {
          notifyPopup(`Error in Deleting SSB Entry!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const noOfDocuments = mainDocuments.length;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mt="10" pt="3">
        <Button
          type="button"
          variant="outlined"
          color="primary"
          //   disabled={currentClaim.status_Id >= 5}
          startIcon={<LocalHospitalIcon />}
          onClick={() => newLine()}
        >
          Add Documents (Main Member)
        </Button>
        <Box>
          <Typography variant="h6"># of Documents...</Typography>
          <TextField
            size="small"
            id="currBalance"
            InputProps={{
              inputComponent: Controls.NumberDecimal,
              style: { textAlign: 'right' }
            }}
            value={noOfDocuments}
          />
        </Box>
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={mainDocuments.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      id,
                      claimRefId,
                      refId,
                      uploadDate,
                      documentType,
                      documentExpiryDate,
                      originalFileName,
                      isValidated,
                      documentPath
                    } = row;
                    const isItemSelected = selected.indexOf(documentType) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">
                          {moment(uploadDate).isValid()
                            ? moment(uploadDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {getDocType({ documentType })}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{originalFileName}</TableCell>
                        <TableCell align="left">
                          {moment(documentExpiryDate).isValid()
                            ? moment(documentExpiryDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{isValidated ? 'Yes' : 'No'}</TableCell>
                        {!documentPath && (
                          <TableCell align="right">
                            <IconButton onClick={() => handleDocUpdate({ refId, claimRefId })}>
                              <LocalHospitalIcon sx={{ color: '#76ff03' }} />
                            </IconButton>
                          </TableCell>
                        )}
                        {/* {documentPath && Number(tenant) < 30 && (
                          <TableCell align="right">
                            {!isValidated && (
                              <IconButton onClick={() => validateDocument({ row })}>
                                <ThumbUpAltIcon sx={{ color: '#76ff03' }} />
                              </IconButton>
                            )}
                            <IconButton
                              onClick={() =>
                                notifyPopup('Decline function not set up yet !!!!!!', 'error')
                              }
                            >
                              <ThumbDownAltIcon sx={{ color: '#f44336' }} />
                            </IconButton>
                          </TableCell>
                        )} */}
                        {documentPath && (
                          <TableCell>
                            <IconButton
                              onClick={() =>
                                setConfirmDialog({
                                  isOpen: true,
                                  title: 'Are you sure you want to Delete Document',
                                  subTitle: "You can't undo this action",
                                  heading: 'Delete Document',
                                  color: '#00000',
                                  onConfirm: () => {
                                    handleDocDelete({ row });
                                  }
                                })
                              }
                            >
                              <DeleteForeverIcon sx={{ color: '#f50057' }} />
                            </IconButton>

                            <IconButton onClick={() => handleDocView({ row })}>
                              <VisibilityIcon sx={{ color: '#03a9f4' }} />
                            </IconButton>
                          </TableCell>
                        )}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Controls.Popup
            title="Add Documents"
            openPopup={openPopupDiag}
            setOpenPopup={setOpenPopupDiag}
          >
            <DocsMainAdd closePopup={closePopupDiag} clientRefId={currentClient.cif_number} />
          </Controls.Popup>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={mainDocuments.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
